(function() {
  var Config, MapSidebar, OverlayStorage, Storage, Trans,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  Config = require('resources/assets/coffee/Core/LaravelJs/Config/Repository').Repository;

  Trans = require('resources/assets/coffee/Core/LaravelJs/Translation/Translator').Translator;

  MapSidebar = require('resources/assets/coffee/Core/MapSidebar').MapSidebar;

  OverlayStorage = require('resources/assets/coffee/Core/OverlayStorage').OverlayStorage;

  Storage = require('resources/assets/coffee/Core/Storage').Storage;

  require('public/js/jquery-ui/jquery-ui.custom.min');

  require('public/bootstrap-2.3.1/docs/assets/js/bootstrap');

  require('public/js/datatables/jquery.dataTables');

  require('public/js/datatables/datatables-bootstrap');

  if (typeof L !== "undefined" && L !== null) {
    require('public/js/Leaflet.Pancontrol/src/L.Control.Pan');
  }

  exports.Application = (function() {
    Application.prototype.options = {
      useMap: true,
      useSidebar: true,
      useNavResize: true
    };

    function Application(options) {
      if (options == null) {
        options = {};
      }
      this.deactivateNavLinks = bind(this.deactivateNavLinks, this);
      this.isDebug = bind(this.isDebug, this);
      this.debugLog = bind(this.debugLog, this);
      this.debugAlert = bind(this.debugAlert, this);
      this._resolvePath = bind(this._resolvePath, this);
      this.addPopup = bind(this.addPopup, this);
      this.doNavChange = bind(this.doNavChange, this);
      this.destroyCurrentPage = bind(this.destroyCurrentPage, this);
      this.handlerStackMaxSize = 10;
      this.eventStack = [];
      this.eventStackMaxSize = 40;
      this.resolverPaths = {
        'grower': 'resources/assets/coffee/Grower',
        'portal': 'resources/assets/coffee/Portal',
        'admin': 'resources/assets/coffee/Admin',
        'core': 'resources/assets/coffee/Core',
        'bower': 'public/bower_components',
        'yarn': 'node_modules',
        'public': 'public/js'
      };
      this.current_page;
      if (this.navLinks == null) {
        this.navLinks = {};
      }
      this.popups = {
        'MissingFileDialog': 'core::MissingFileDialog',
        'NonExistentUserDialog': 'core::NonExistentUserDialog'
      };
      window.DEBUG = false;
      this.options = $.extend(this.options, options);
      $('#reload-site button').bind('click', function() {
        return window.location.reload(true);
      });
      $('#download-complete a').bind('click', function() {
        $('#download-complete').toggle('slide');
        return $.post('backend/grower/download/get-complete-data-packages').then((function(_this) {
          return function(response) {
            var i, id, len, package_ids, results;
            package_ids = response.data;
            results = [];
            for (i = 0, len = package_ids.length; i < len; i++) {
              id = package_ids[i];
              results.push(window.open("backend/grower/download/download?id=" + id));
            }
            return results;
          };
        })(this));
      });
    }

    Application.prototype.boot = function() {
      this.storage = new Storage();
      this.initGlobals();
      if (this.options.useMap) {
        this.initMap();
      }
      if (this.options.useSidebar) {
        this.initSidebar();
      }
      this.init();
      $(window).trigger('app:booting');
      if (this.options.useNavResize) {
        this.initNavbarResize();
      }
      $('.down-dialog').modal({
        backdrop: 'static',
        keyboard: false,
        show: false
      });
      return $(window).trigger('app:ready', this);
    };

    Application.prototype.initNavbarResize = function() {
      return setTimeout((function(_this) {
        return function() {
          var ResizeDropper;
          ResizeDropper = _this.loadClass('core::ResponsiveNavDropper');
          _this._resizeDropper = new ResizeDropper();
          return _this._resizeDropper.attach($('#nav_primary_links'), 'More', 80);
        };
      })(this), 0);
    };

    Application.prototype.initSidebar = function() {
      var map, ref;
      map = (ref = this.map) != null ? ref : null;
      return this.sidebar = new MapSidebar(map);
    };

    Application.prototype.destroyCurrentPage = function() {
      if (this.current_page != null) {
        return this.current_page.destroy();
      }
    };

    Application.prototype.doNavChange = function(sel) {
      var elem, hClass, handler, name, path, sref;
      if (sel == null) {
        sel = null;
      }
      elem = this.nav_element_clicked;
      if (elem == null) {
        return;
      }
      this.nav_element_clicked = null;
      if (sel != null) {
        $(document).ajaxStop(function() {
          $('div.sidebar_content .nav-tabs a').eq(sel).trigger('click');
          $(document).unbind('ajaxStop');
        });
      }
      $('#nav_primary_links li, #nav_contact_link li').removeClass('active');
      this.deactivateNavLinks();
      $(elem).parents('li').addClass('active');
      sref = $(elem).attr('ui-sref');
      if ((sref != null) && sref !== '') {
        this.destroyCurrentPage();
        return;
      }
      handler = $(elem).data('handler') || $(elem).text();
      handler = handler.replace(/\s+/g, '');
      name = handler.toLowerCase();
      path = List.retrieve(this.navLinks, handler);
      if (!path) {
        alert("No navLink handler found: " + handler + ". Check the navLinks object in the " + App.constructor.name + " application class");
        return;
      }
      this.destroyCurrentPage();
      hClass = this.loadClass(path);
      this.current_page = new hClass(name);
      this.current_page.navBtn = $(elem).parents('li');
      this.current_page.init();
      if (this.sidebar != null) {
        if (this.current_page.sidebar_open === true) {
          return this.sidebar.open();
        } else if (this.current_page.sidebar_open === false) {
          return this.sidebar.close();
        }
      }
    };

    Application.prototype.init = function() {
      return $.post('backend/grower/download/get-complete-data-packages').then((function(_this) {
        return function(response) {
          var packages;
          packages = response.data.length;
          if (packages) {
            return $('#download-complete').toggle('slide');
          }
        };
      })(this));
    };

    Application.prototype.initGlobals = function() {
      var ref, touch;
      window.Config = new Config((ref = this.getConfig()) != null ? ref : {});
      window.Trans = new Trans(window.Config);
      window.Spinner = this.load('bower::spinjs/spin');
      $(window).trigger('config:ready', this);
      this.loadGlobalClass('core::DependencyInjection');
      this.loadGlobalClass('core::KoModel');
      this.loadGlobalClass('core::Handler');
      this.loadGlobalClass('core::DialogHandler');
      this.loadGlobalClass('core::FullPageHandler');
      this.loadGlobal('core::List', 'List');
      this.loadGlobal('bower::lodash/dist/lodash', '_');
      this.loadGlobal('moment', 'moment');
      this.loadGlobal('bower::phpjs/src/php/strings/strnatcasecmp', 'strnatcasecmp');
      window.TAFFY = this.load('public::taffydb/taffy-with-natsort').taffy;
      window.ko = this.load('bower::knockout/dist/knockout');
      window.nedb = this.load('public::nedb/nedb');
      this.load('core::knockout/checkableButton');
      this.load('core::knockout/valueTriggerChange');
      this.load('bower::jsrender/jsrender');
      $.views.settings.delimiters('{!', '!}');
      this.load('core::widget_multidelete');
      this.load('core::widget_resizr');
      this.load('core::widget_message_writer');
      this.load('core::widget_listitems');
      this.load('core::widget_myUploader');
      this.load('public::smartresize/smartresize');
      this.load('bower::jquery-maskedinputs/dist/jquery.maskedinput');
      this.load('public::jquery.validationEngine');
      this.load('public::jquery.validationEngine-en');
      this.load('bower::jstree-dist/jquery.jstree');
      this.load('bower::jquery-timepicker-jt/jquery.timepicker');
      this.load('bower::bootstrapx-clickover/js/bootstrapx-clickover');
      this.load('bower::select2/select2');
      this.load('bower::bootstrap-daterangepicker/daterangepicker');
      this.load('core::handsontable/getRowOfSourceData');
      this.load('core::handsontable/status-cell-type');
      this.load('core::handsontable/better-autocomplete');
      this.load('core::handsontable/fancy-validation');
      this.load('core::handsontable/row-col-helpers');
      window.mOxie = this.load('bower::plupload/js/moxie.min').mOxie;
      this.load('bower::plupload/js/plupload.dev');
      this.load('bower::plupload/js/jquery.plupload.queue/jquery.plupload.queue');
      touch = this.loadClass('core::utils/touch');
      touch.initialize();
      window.isDebug = this.isDebug;
      window.debugLog = this.debugLog;
      return window.debugAlert = this.debugAlert;
    };

    Application.prototype.addPopup = function(popupname, params) {
      var h, pop, ref;
      if (params == null) {
        params = {};
      }
      pop = (ref = List.retrieve(this.popups, popupname)) != null ? ref : popupname;
      h = this.loadClass(pop);
      if (h == null) {
        throw new Error("Unable to create popup " + popupname + ", class not found");
        return;
      }
      h = new h();
      h.loadLayoutPostOptions = params;
      return h.init();
    };

    Application.prototype.getConfig = function() {
      return void 0;
    };

    Application.prototype.initMap = function() {
      var maxZoom;
      if (typeof L === "undefined" || L === null) {
        window.L = {
          Class: {
            extend: (function() {
              return void 0;
            })
          },
          Util: {
            extend: (function() {
              return void 0;
            })
          },
          GeoJSON: {}
        };
        throw new Error('Map not loaded; No Leaflet found.');
        this.layer_store = new Storage();
        this.layer_store.loadField = function() {
          return void 0;
        };
        return;
      }
      App.load('core::globals/modules');
      this.layer_store = new OverlayStorage();
      if (L.mapbox == null) {
        console.error('Failed to load map');
        return;
      }
      maxZoom = window.Config.get('app.locale') === 'en_AU' ? 16 : 18;
      L.mapbox.accessToken = 'pk.eyJ1IjoibXlmYXJtcyIsImEiOiJaY2gzXzJvIn0.Kh5pHZFlBBoMXbWMtl246A';
      this.map = L.map('map_canvas', {
        zoomControl: false,
        attributionControl: {
          compact: true
        },
        continuousWorld: false,
        legendControl: {
          position: 'topleft'
        },
        minZoom: 2,
        maxZoom: maxZoom,
        interactive: false
      });
      L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + L.mapbox.accessToken, {
        id: 'myfarms/clzjy3pnf016y01pa70lxfwbv'
      }).addTo(this.map);
      App.recenterMap = true;
      setTimeout((function(_this) {
        return function() {
          if (App.recenterMap) {
            return _this.map.setView(user_address_lat_lng, 14);
          }
        };
      })(this), 1000);
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.userMarker = L.marker(user_address_lat_lng).addTo(this.map);
      }
      this.map.addControl(new L.Control.Pan({
        position: 'topright'
      }));
      this.map.addControl(new L.Control.Zoom({
        position: 'topright'
      }));
      this.map.addControl(new L.control.scale({
        metric: false
      }));
      this.map.whenReady((function(_this) {
        return function() {
          return _this.map.locate({
            setView: true,
            watch: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            maxZoom: 17
          });
        };
      })(this));
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.map.on('locationfound', (function(_this) {
          return function(location) {
            return _this.userMarker.setLatLng(location.latlng);
          };
        })(this));
        return $(window).trigger('map_ready');
      }
    };

    Application.prototype.load = function(file) {
      file = this._resolvePath(file);
      if (file != null) {
        return require(file);
      }
    };

    Application.prototype.loadGlobal = function(file, name) {
      file = this._resolvePath(file);
      window[name] = this.load(file);
      return window[name];
    };

    Application.prototype.loadClass = function(file, classname) {
      var loaded;
      if (classname == null) {
        classname = null;
      }
      file = this._resolvePath(file);
      if (classname == null) {
        classname = this._findClassname(file);
      }
      loaded = this.load(file);
      if (loaded[classname] == null) {
        return loaded;
      }
      return loaded[classname];
    };

    Application.prototype.loadGlobalClass = function(file, classname, name) {
      if (classname == null) {
        classname = null;
      }
      if (name == null) {
        name = null;
      }
      file = this._resolvePath(file);
      if (classname == null) {
        classname = this._findClassname(file);
      }
      if (name == null) {
        name = classname;
      }
      return window[name] = this.loadClass(file, classname);
    };

    Application.prototype._findClassname = function(file) {
      var sp;
      sp = file.match(/\/(\w+)$/);
      if (sp && sp.length > 1) {
        return sp[1];
      }
    };

    Application.prototype._resolvePath = function(path) {
      var split;
      if (path == null) {
        return null;
      }
      split = path.split('::');
      if (split && split.length === 2) {
        return this.resolverPaths[split[0]] + '/' + split[1];
      }
      return path;
    };

    Application.prototype.debugAlert = function(val) {
      if (this.isDebug()) {
        return alert(val);
      }
    };

    Application.prototype.debugLog = function(val) {
      if (this.isDebug()) {
        return console.log(val);
      }
    };

    Application.prototype.isDebug = function() {
      var host;
      host = document.location.hostname.split('.');
      if (window.DEBUG && (host[0] === 'dev' || !(host[host.length - 2] === 'myfarms' && host[host.length - 1] === 'com'))) {
        return true;
      }
      return false;
    };

    Application.prototype.deactivateNavLinks = function(exclude) {
      var condition;
      if (exclude == null) {
        exclude = null;
      }
      condition = exclude ? ":not(:contains('" + exclude + "'))" : '';
      return $("#nav_primary_links li" + condition + ", #nav_contact_link li").removeClass('active');
    };

    return Application;

  })();

}).call(this);
